export default () => {
  return {
    'amount_before': '0,00',
    'change': '0,00',
    'amount_after': '0,00',
    'free_documents': '0',
  };
}
